import { Component } from '@angular/core';
import { ListService } from '@abp/ng.core';
import { ConfirmationService } from '@abp/ng.theme.shared';
import {
  GenericForm,
  LocationTypes,
  ZnHierarchicalViewComponent,
} from '@zendra/shared';
import { WoodCertificationDetailService } from '../../proxy/geographic/controllers';
import { WoodCertificationDetailPlanningOrchestratorService } from 'projects/orchestrator/src/lib/proxy/orchestrator/controllers/wood-certification-detail-planning-orchestrator.service';
import {
  CERTIFIEDREGISTERS_CONFIG,
  CERTIFIEDREGISTERS_FIELDS,
} from './certified-registers.config';
import { CertifiedLocationBaseComponent } from '../certified-location-base.component';

@Component({
  selector: 'app-certified-registers',
  imports: [
    GenericForm,
    ZnHierarchicalViewComponent,
  ],
  providers: [
    ListService,
    WoodCertificationDetailService,
    WoodCertificationDetailPlanningOrchestratorService,
    ConfirmationService,
  ],
  templateUrl: './certified-registers.html'
})
export class CertifiedRegisters extends CertifiedLocationBaseComponent {
  config = CERTIFIEDREGISTERS_CONFIG;
  fields = CERTIFIEDREGISTERS_FIELDS;

  protected getWoodCertificationType(): LocationTypes {
    return LocationTypes.Register;
  }

  protected getEntityName(): string {
    return 'CertifiedRegisters';
  }
}
